import Menu from "../../components/Menu";

export default function Labs(){
  const screenTela = <h1>Laboratórios</h1>

  return (
    <Menu screen={screenTela} />
  )
}